module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8r7n2n5n-141f522d9767f5ff210dd3374457c223.svg";